{
  "bookmarks": {
    "framingFallback": "Position",
    "missingNode": "Node supprimé",
    "nodeCount_one": "{{count}} node",
    "nodeCount_other": "{{count}} nodes",
    "errors": {
      "add": "Impossible d'ajouter le favori",
      "rename": "Impossible de renommer le favori",
      "reorder": "Impossible de réordonner les favoris",
      "remove": "Impossible de retirer le favori"
    }
  },
  "speech": {
    "recordingUnsupported": "L'enregistrement audio n'est pas pris en charge par ce navigateur.",
    "noSpeech": "Aucune parole détectée.",
    "transcriptionFailed": "La transcription a échoué. Veuillez réessayer.",
    "liveUnavailable": "La dictée en direct n'est pas disponible sur cet appareil.",
    "notConfigured": "La dictée vocale n'est pas configurée.",
    "microphone": {
      "denied": "Accès au micro refusé. Autorisez le micro dans les réglages de votre navigateur.",
      "notFound": "Aucun micro détecté.",
      "busy": "Micro indisponible (déjà utilisé par une autre application ?).",
      "overconstrained": "Le micro ne prend pas en charge les réglages demandés.",
      "unavailable": "Impossible d'accéder au micro."
    },
    "server": {
      "badMessage": "Erreur de communication avec le serveur vocal.",
      "idleTimeout": "Session vocale fermée pour inactivité.",
      "sessionTooLong": "Durée maximale de dictée atteinte.",
      "upstreamError": "Le service de transcription est momentanément indisponible.",
      "backpressure": "Connexion trop lente pour la dictée en direct.",
      "shutdown": "Le serveur vocal redémarre, veuillez réessayer dans un instant.",
      "internal": "Erreur interne du serveur vocal.",
      "generic": "Erreur du serveur vocal.",
      "unreachable": "Impossible de joindre le serveur vocal. Réessayez dans quelques secondes.",
      "interrupted": "La connexion au serveur vocal a été interrompue.",
      "noAnswer": "Le serveur vocal n'a pas répondu, la dictée n'a pas pu être transcrite.",
      "notResponding": "Le serveur vocal ne répond pas. Réessayez dans quelques secondes.",
      "noTranscript": "Le serveur vocal n'a renvoyé aucune transcription. Veuillez réessayer."
    }
  },
  "nodes": {
    "cannotDuplicateType": "Ce type de node ne peut plus être dupliqué.",
    "framesInFrame": "Une frame ne peut pas aller dans une frame : seul son contenu a été ajouté.",
    "someTypesCannotBePasted": "Certains types de nodes ne peuvent plus être collés.",
    "someTypesCannotBeDuplicated": "Certains types de nodes ne peuvent plus être dupliqués.",
    "addFailed_one": "Impossible d'ajouter le node",
    "addFailed_other": "Impossible d'ajouter les nodes",
    "updateFailed": "Erreur lors de la mise à jour"
  },
  "nole": {
    "threadWithoutCanvas": "Impossible de créer une conversation sans canvas.",
    "sendFailed": "Impossible d'envoyer le message. Veuillez réessayer.",
    "nothingToStop": "Rien à arrêter : Nolë a déjà terminé.",
    "stopFailed": "Impossible d'arrêter la réponse en cours",
    "switchModelFailed": "Impossible de changer le modèle de la tâche en cours",
    "newSessionFailed": "Impossible de démarrer une nouvelle session."
  },
  "canvases": {
    "deleteFailed": "Erreur lors de la suppression du canvas."
  },
  "canvasDrop": {
    "rowFailed": "Impossible de placer la ligne sur le canvas"
  },
  "edges": {
    "updateFailed": "Erreur lors de la mise à jour de la connexion",
    "addFailed": "Impossible d'ajouter la connexion"
  },
  "history": {
    "nothingToUndo": "Plus rien à annuler",
    "nothingToRedo": "Plus rien à rétablir",
    "undoFailed": "Impossible d'annuler",
    "redoFailed": "Impossible de rétablir"
  },
  "openSelection": {
    "truncated_one": "Seuls les {{max}} premiers nodes sur {{count}} ont été ouverts",
    "truncated_other": "Seuls les {{max}} premiers nodes sur {{count}} ont été ouverts"
  },
  "links": {
    "invalidUrl": "URL invalide"
  },
  "databaseDrop": {
    "fallbackTitle": "la base de données",
    "addFailed": "Impossible d'ajouter le node à la base de données",
    "added_one": "Placé dans {{title}}.",
    "added_other": "{{count}} nodes placés dans {{title}}."
  },
  "transcription": {
    "startFailed": "Impossible de lancer la transcription"
  },
  "ingest": {
    "addedNamed": "Ajouté au canvas : {{label}}",
    "nodesAdded_one": "{{count}} node ajouté au canvas",
    "nodesAdded_other": "{{count}} nodes ajoutés au canvas",
    "filesFailed_one": "Un fichier n'a pas pu être ajouté",
    "filesFailed_other": "{{count}} fichiers n'ont pas pu être ajoutés",
    "imageAdded": "Image ajoutée au canvas",
    "linkAdded": "Lien ajouté au canvas",
    "documentCreated": "Document créé"
  },
  "reveal": {
    "notFound": {
      "block": "Bloc introuvable : il a sans doute été supprimé.",
      "column": "Colonne introuvable : elle a sans doute été supprimée.",
      "row": "Ligne introuvable : elle a été supprimée, ou la recherche ou les filtres du tableau la masquent.",
      "cell": "Cellule introuvable : elle a été supprimée, ou la recherche ou les filtres du tableau la masquent."
    }
  },
  "copyIds": {
    "copied_one": "ID du node copié",
    "copied_other": "ID des nodes copiés",
    "failed": "Impossible de copier les ID",
    "menu_one": "Copier l'ID",
    "menu_other": "Copier les ID",
    "nodeIds_one": "ID du node",
    "nodeIds_other": "ID des nodes",
    "canvasAndNodeIds_one": "ID du canvas et du node",
    "canvasAndNodeIds_other": "ID du canvas et des nodes"
  },
  "canvasUi": {
    "hiddenHint": "Interface masquée. Appuyez sur {{key}} pour la réafficher."
  },
  "auth": {
    "signedOut": "Déconnexion effectuée",
    "signOutFailed": "Erreur lors de la déconnexion"
  },
  "sync": {
    "edgePoints": "Impossible d'enregistrer les points de la connexion",
    "nodeSize": "Impossible d'enregistrer la taille du node",
    "nodePosition": "Impossible d'enregistrer la position du node",
    "frameResize": "Impossible de redimensionner la frame",
    "arrange": "Impossible de disposer les nodes",
    "delete": "Impossible de supprimer ces éléments"
  },
  "arrange": {
    "left": "Aligner à gauche",
    "hcenter": "Centrer horizontalement",
    "right": "Aligner à droite",
    "top": "Aligner en haut",
    "vcenter": "Centrer verticalement",
    "bottom": "Aligner en bas",
    "distributeH": "Répartir horizontalement",
    "distributeV": "Répartir verticalement",
    "tidy": "Ranger"
  },
  "tasks": {
    "clearFailed": "Impossible de retirer cette tâche.",
    "undoFailed": "Impossible d'annuler."
  },
  "upload": {
    "failed": "Échec de l'import"
  },
  "usage": {
    "periodDays_one": "{{count}} jour",
    "periodDays_other": "{{count}} jours",
    "periodMonths_one": "{{count}} mois",
    "periodMonths_other": "{{count}} mois"
  },
  "voiceMemo": {
    "saveFailed": "Le mémo vocal n'a pas pu être enregistré.",
    "unavailable": "L'enregistrement audio n'est pas disponible."
  },
  "layering": {
    "front": "Mettre au premier plan",
    "forward": "Avancer",
    "backward": "Reculer",
    "back": "Mettre à l'arrière-plan"
  },
  "presence": {
    "someone": "Quelqu'un"
  },
  "pdf": {
    "page": "Page {{page}}"
  },
  "runStatus": {
    "running": {
      "label": "En cours",
      "description": "Nolë travaille sur cette conversation."
    },
    "waiting": {
      "label": "Attend votre réponse",
      "description": "Nolë vous a posé une question et attend votre réponse."
    },
    "aborted": {
      "label": "Interrompue",
      "description": "La réponse a été interrompue."
    },
    "error": {
      "label": "Échec",
      "description": "La dernière réponse a échoué."
    },
    "done": {
      "label": "Terminée",
      "description": "Nolë a terminé cette tâche."
    }
  },
  "embeds": {
    "googleDocs": "Modifiez un document directement sur le canvas.",
    "googleSheets": "Modifiez une feuille de calcul directement sur le canvas.",
    "googleSlides": "Modifiez une présentation directement sur le canvas.",
    "googleForms": "Remplissez un formulaire sans quitter le canvas.",
    "googleDrive": "Prévisualisez un fichier Drive (PDF, image, vidéo…).",
    "figma": "Un fichier de design, un tableau FigJam ou un prototype, en direct.",
    "youtube": "Lisez une vidéo ou une playlist.",
    "vimeo": "Lisez une vidéo, liens privés compris.",
    "loom": "Lisez un enregistrement d'écran.",
    "spotify": "Un titre, un album, une playlist ou un podcast."
  }
}
